import React from 'react';

import { DropdownWrapper, EntityCard, IconGroupSolid } from '@trqk/components';

import { locale } from '@trqk/utils';
import { useDashboard } from '../../../hooks';

const height = 76;
const width = 280;
const expandedHeaderHeight = 40;
const expandedFooterHeight = 60;
const maxListLength = 4;

const allEntitiesIcon = <IconGroupSolid fillColor="white" width={30} />;

export const EntitySelectorPreview = (): JSX.Element | null => {
    const { dashboard } = useDashboard();

    const name = dashboard?.statement_info?.name ?? '';
    const proLookup = dashboard?.statement_info?.pro ?? null;
    const role_type: ProAffiliateType =
        dashboard?.statement_info?.role_type ?? ('unknown' as ProAffiliateType);
    const entities: TrqkEntity[] = [];
    let selectedEntity: TrqkEntity | null = null;

    if (proLookup !== null) {
        selectedEntity = {
            id: '',
            name,
            pro: proLookup,
            // ProRoleType and ProAffiliateType are essentially the same; really, only one of
            // them should be defined in the schema, but they are both used, so it's safe to coerce
            // one to the other here.
            role_type: role_type as unknown as ProRoleType,
            ROW_LOCK: null,
        };
    }

    const showScrollArea = entities.length > maxListLength;

    const viewAllOptionHeight = height;

    const scrollAreaHeight = showScrollArea
        ? maxListLength * height
        : entities.length * height + viewAllOptionHeight;

    const listHeight =
        scrollAreaHeight - height + expandedHeaderHeight + expandedFooterHeight;

    return (
        <div className="fixed top-0 right-0 mt-8 mr-8 z-50">
            <DropdownWrapper
                boxShadowWhenClosed={true}
                boxShadowWhenOpen={true}
                caretWidth={18}
                disabled={true}
                height={height}
                leftPadding={false}
                listHeight={listHeight}
                isExpanded={false}
                selectedLabel={
                    <EntityCard
                        avatarLabel={
                            selectedEntity === null
                                ? allEntitiesIcon
                                : undefined
                        }
                        height={height}
                        loading={false}
                        name={selectedEntity?.name ?? locale.enUS.ALL_ENTITIES}
                        pro={selectedEntity?.pro ?? undefined}
                        roleType={selectedEntity?.role_type ?? null}
                        width={width}
                    />
                }
                setIsExpanded={(): void => undefined}
                width={width}
                borderConfig="transparent.large"
            />
        </div>
    );
};
